module.exports = __webpack_public_path__ + "img/kinderplus_logo_redondo.dae40793.png";